// Images
// -3
import GitHubCopilotLogo_1x from "./../assets/CertificationsPage/Logos/-3GitHubCopilotLogo/GitHubCopilotLogo_1x.webp";
import GitHubCopilotLogo_2x from "./../assets/CertificationsPage/Logos/-3GitHubCopilotLogo/GitHubCopilotLogo_2x.webp";

import GitHubCopilotCertificate_1x from "./../assets/CertificationsPage/Certificates/-3GitHubCopilotCertificate/GitHubCopilotCertificate_1x.webp";
import GitHubCopilotCertificate_2x from "./../assets/CertificationsPage/Certificates/-3GitHubCopilotCertificate/GitHubCopilotCertificate_2x.webp";

// -2
import ClaudeCodeLogo_1x from "./../assets/CertificationsPage/Logos/-2ClaudeCodeLogo/ClaudeCodeLogo_1x.webp";
import ClaudeCodeLogo_2x from "./../assets/CertificationsPage/Logos/-2ClaudeCodeLogo/ClaudeCodeLogo_2x.webp";

import ClaudeCodeCertificate_1x from "./../assets/CertificationsPage/Certificates/-2ClaudeCodeCertificate/ClaudeCodeCertificate_1x.webp";
import ClaudeCodeCertificate_2x from "./../assets/CertificationsPage/Certificates/-2ClaudeCodeCertificate/ClaudeCodeCertificate_2x.webp";

// -1
import NextJSLogo_1x from "./../assets/CertificationsPage/Logos/-1NextJSLogo/NextJSLogo_1x.webp";
import NextJSLogo_2x from "./../assets/CertificationsPage/Logos/-1NextJSLogo/NextJSLogo_2x.webp";

import NextJSCertificate_1x from "./../assets/CertificationsPage/Certificates/-1NextJSCertificate/NextJSCertificate_1x.webp";
import NextJSCertificate_2x from "./../assets/CertificationsPage/Certificates/-1NextJSCertificate/NextJSCertificate_2x.webp";

// 1
import MSSpecialistLogo_1x from "./../assets/CertificationsPage/Logos/1MSSpecialist/MSSpecialistLogo_1x.webp";
import MSSpecialistLogo_2x from "./../assets/CertificationsPage/Logos/1MSSpecialist/MSSpecialistLogo_2x.webp";
import MSSpecialistLogo_M1x from "./../assets/CertificationsPage/Logos/0Mobile/1MSSpecialist/MSSpecialist_1x.webp";
import MSSpecialistLogo_M2x from "./../assets/CertificationsPage/Logos/0Mobile/1MSSpecialist/MSSpecialist_2x.webp";

import MSSpecialistCertificate_1x from "./../assets/CertificationsPage/Certificates/1MSSpecialistCertificate/MSSpecialistCertificate_1x.webp";
import MSSpecialistCertificate_2x from "./../assets/CertificationsPage/Certificates/1MSSpecialistCertificate/MSSpecialistCertificate_2x.webp";
import MSSpecialistCertificate_M1x from "./../assets/CertificationsPage/Certificates/0Mobile/1MSSpecialistCertificate/MSSpecialistCertificate_1x.webp";
import MSSpecialistCertificate_M2x from "./../assets/CertificationsPage/Certificates/0Mobile/1MSSpecialistCertificate/MSSpecialistCertificate_2x.webp";

// 2
import MSSolutionDevLogo_1x from "./../assets/CertificationsPage/Logos/2MSSolutionDev/MSSolutionDevLogo_1x.webp";
import MSSolutionDevLogo_2x from "./../assets/CertificationsPage/Logos/2MSSolutionDev/MSSolutionDevLogo_2x.webp";
import MSSolutionDevLogo_M1x from "./../assets/CertificationsPage/Logos/0Mobile/2MSSolutionDev/MSSolutionDev_1x.webp";
import MSSolutionDevLogo_M2x from "./../assets/CertificationsPage/Logos/0Mobile/2MSSolutionDev/MSSolutionDev_2x.webp";

import MSSolutionDevCertificate_1x from "./../assets/CertificationsPage/Certificates/2MSSolutionDevCertificate/MSSolutionDevCertificate_1x.webp";
import MSSolutionDevCertificate_2x from "./../assets/CertificationsPage/Certificates/2MSSolutionDevCertificate/MSSolutionDevCertificate_2x.webp";
import MSSolutionDevCertificate_M1x from "./../assets/CertificationsPage/Certificates/0Mobile/2MSSolutionDevCertificate/MSSolutionDevCertificate_1x.webp";
import MSSolutionDevCertificate_M2x from "./../assets/CertificationsPage/Certificates/0Mobile/2MSSolutionDevCertificate/MSSolutionDevCertificate_2x.webp";

// 3
import MSCertifiedLogo_1x from "./../assets/CertificationsPage/Logos/3MSCertified/MSCertifiedLogo_1x.webp";
import MSCertifiedLogo_2x from "./../assets/CertificationsPage/Logos/3MSCertified/MSCertifiedLogo_2x.webp";
import MSCertifiedLogo_M1x from "./../assets/CertificationsPage/Logos/0Mobile/3MSCertified/MSCertified_1x.webp";
import MSCertifiedLogo_M2x from "./../assets/CertificationsPage/Logos/0Mobile/3MSCertified/MSCertified_2x.webp";

import MSCertifiedCertificate_1x from "./../assets/CertificationsPage/Certificates/3MSCertifiedCertificate/MSCertifiedCertificate_1x.webp";
import MSCertifiedCertificate_2x from "./../assets/CertificationsPage/Certificates/3MSCertifiedCertificate/MSCertifiedCertificate_2x.webp";
import MSCertifiedCertificate_M1x from "./../assets/CertificationsPage/Certificates/0Mobile/3MSCertifiedCertificate/MSCertifiedCertificate_1x.webp";
import MSCertifiedCertificate_M2x from "./../assets/CertificationsPage/Certificates/0Mobile/3MSCertifiedCertificate/MSCertifiedCertificate_2x.webp";

// 4
import IxDFLogo_1x from "./../assets/CertificationsPage/Logos/4IxDFLogo/IxDFLogo_1x.webp";
import IxDFLogo_2x from "./../assets/CertificationsPage/Logos/4IxDFLogo/IxDFLogo_2x.webp";
import IxDFLogo_M1x from "./../assets/CertificationsPage/Logos/0Mobile/4IxDFLogo/IxDFLogo_1x.webp";
import IxDFLogo_M2x from "./../assets/CertificationsPage/Logos/0Mobile/4IxDFLogo/IxDFLogo_2x.webp";

import IxDF1Certificate_1x from "./../assets/CertificationsPage/Certificates/4IxDFCertificates/IxDF1Certificate/IxDF1Certificate_1x.webp";
import IxDF1Certificate_2x from "./../assets/CertificationsPage/Certificates/4IxDFCertificates/IxDF1Certificate/IxDF1Certificate_2x.webp";
import IxDF1Certificate_M1x from "./../assets/CertificationsPage/Certificates/0Mobile/4IxDFCertificates/IxDF1Certificate/IxDF1Certificate_1x.webp";
import IxDF1Certificate_M2x from "./../assets/CertificationsPage/Certificates/0Mobile/4IxDFCertificates/IxDF1Certificate/IxDF1Certificate_2x.webp";

import IxDF2Certificate_1x from "./../assets/CertificationsPage/Certificates/4IxDFCertificates/IxDF2Certificate/IxDF2Certificate_1x.webp";
import IxDF2Certificate_2x from "./../assets/CertificationsPage/Certificates/4IxDFCertificates/IxDF2Certificate/IxDF2Certificate_2x.webp";
import IxDF2Certificate_M1x from "./../assets/CertificationsPage/Certificates/0Mobile/4IxDFCertificates/IxDF2Certificate/IxDF2Certificate_1x.webp";
import IxDF2Certificate_M2x from "./../assets/CertificationsPage/Certificates/0Mobile/4IxDFCertificates/IxDF2Certificate/IxDF2Certificate_2x.webp";

import IxDF3Certificate_1x from "./../assets/CertificationsPage/Certificates/4IxDFCertificates/IxDF3Certificate/IxDF3Certificate_1x.webp";
import IxDF3Certificate_2x from "./../assets/CertificationsPage/Certificates/4IxDFCertificates/IxDF3Certificate/IxDF3Certificate_2x.webp";
import IxDF3Certificate_M1x from "./../assets/CertificationsPage/Certificates/0Mobile/4IxDFCertificates/IxDF3Certificate/IxDF3Certificate_1x.webp";
import IxDF3Certificate_M2x from "./../assets/CertificationsPage/Certificates/0Mobile/4IxDFCertificates/IxDF3Certificate/IxDF3Certificate_2x.webp";

import IxDF4Certificate_1x from "./../assets/CertificationsPage/Certificates/4IxDFCertificates/IxDF4Certificate/IxDF4Certificate_1x.webp";
import IxDF4Certificate_2x from "./../assets/CertificationsPage/Certificates/4IxDFCertificates/IxDF4Certificate/IxDF4Certificate_2x.webp";
import IxDF4Certificate_M1x from "./../assets/CertificationsPage/Certificates/0Mobile/4IxDFCertificates/IxDF4Certificate/IxDF4Certificate_1x.webp";
import IxDF4Certificate_M2x from "./../assets/CertificationsPage/Certificates/0Mobile/4IxDFCertificates/IxDF4Certificate/IxDF4Certificate_2x.webp";

import IxDF5Certificate_1x from "./../assets/CertificationsPage/Certificates/4IxDFCertificates/IxDF5Certificate/IxDF5Certificate_1x.webp";
import IxDF5Certificate_2x from "./../assets/CertificationsPage/Certificates/4IxDFCertificates/IxDF5Certificate/IxDF5Certificate_2x.webp";
import IxDF5Certificate_M1x from "./../assets/CertificationsPage/Certificates/0Mobile/4IxDFCertificates/IxDF5Certificate/IxDF5Certificate_1x.webp";
import IxDF5Certificate_M2x from "./../assets/CertificationsPage/Certificates/0Mobile/4IxDFCertificates/IxDF5Certificate/IxDF5Certificate_2x.webp";

// 5
import FigmaLogo_1x from "./../assets/CertificationsPage/Logos/5FigmaLogo/FigmaLogo_1x.webp";
import FigmaLogo_2x from "./../assets/CertificationsPage/Logos/5FigmaLogo/FigmaLogo_2x.webp";
import FigmaLogo_M1x from "./../assets/CertificationsPage/Logos/0Mobile/5FigmaLogo/FigmaLogo_1x.webp";
import FigmaLogo_M2x from "./../assets/CertificationsPage/Logos/0Mobile/5FigmaLogo/FigmaLogo_2x.webp";

import FigmaAdvancedCertificate_1x from "./../assets/CertificationsPage/Certificates/5FigmaCertificates/FigmaAdvancedCertificate/FigmaAdvancedCertificate_1x.webp";
import FigmaAdvancedCertificate_2x from "./../assets/CertificationsPage/Certificates/5FigmaCertificates/FigmaAdvancedCertificate/FigmaAdvancedCertificate_2x.webp";
import FigmaAdvancedCertificate_M1x from "./../assets/CertificationsPage/Certificates/0Mobile/5FigmaCertificates/FigmaAdvancedCertificate/FigmaAdvancedCertificate_1x.webp";
import FigmaAdvancedCertificate_M2x from "./../assets/CertificationsPage/Certificates/0Mobile/5FigmaCertificates/FigmaAdvancedCertificate/FigmaAdvancedCertificate_2x.webp";

import FigmaBasicCertificate_1x from "./../assets/CertificationsPage/Certificates/5FigmaCertificates/FigmaBasicCertificate/FigmaBasicCertificate_1x.webp";
import FigmaBasicCertificate_2x from "./../assets/CertificationsPage/Certificates/5FigmaCertificates/FigmaBasicCertificate/FigmaBasicCertificate_2x.webp";
import FigmaBasicCertificate_M1x from "./../assets/CertificationsPage/Certificates/0Mobile/5FigmaCertificates/FigmaBasicCertificate/FigmaBasicCertificate_1x.webp";
import FigmaBasicCertificate_M2x from "./../assets/CertificationsPage/Certificates/0Mobile/5FigmaCertificates/FigmaBasicCertificate/FigmaBasicCertificate_2x.webp";

// 6
import IllustratorLogo_1x from "./../assets/CertificationsPage/Logos/6IllustratorLogo/IllustratorLogo_1x.webp";
import IllustratorLogo_2x from "./../assets/CertificationsPage/Logos/6IllustratorLogo/IllustratorLogo_2x.webp";
import IllustratorLogo_M1x from "./../assets/CertificationsPage/Logos/0Mobile/6IllustratorLogo/IllustratorLogo_1x.webp";
import IllustratorLogo_M2x from "./../assets/CertificationsPage/Logos/0Mobile/6IllustratorLogo/IllustratorLogo_2x.webp";

import IllustratorCertificate_1x from "./../assets/CertificationsPage/Certificates/6IllustratorCertificate/IllustratorCertificate_1x.webp";
import IllustratorCertificate_2x from "./../assets/CertificationsPage/Certificates/6IllustratorCertificate/IllustratorCertificate_2x.webp";
import IllustratorCertificate_M1x from "./../assets/CertificationsPage/Certificates/0Mobile/6IllustratorCertificate/IllustratorCertificate_1x.webp";
import IllustratorCertificate_M2x from "./../assets/CertificationsPage/Certificates/0Mobile/6IllustratorCertificate/IllustratorCertificate_2x.webp";

// 7
import PhotoshopLogo_1x from "./../assets/CertificationsPage/Logos/7PhotoshopLogo/PhotoshopLogo_1x.webp";
import PhotoshopLogo_2x from "./../assets/CertificationsPage/Logos/7PhotoshopLogo/PhotoshopLogo_2x.webp";
import PhotoshopLogo_M1x from "./../assets/CertificationsPage/Logos/0Mobile/7PhotoshopLogo/PhotoshopLogo_1x.webp";
import PhotoshopLogo_M2x from "./../assets/CertificationsPage/Logos/0Mobile/7PhotoshopLogo/PhotoshopLogo_2x.webp";

import PhotoshopCertificate_1x from "./../assets/CertificationsPage/Certificates/7PhotoshopCertificate/PhotoshopCertificate_1x.webp";
import PhotoshopCertificate_2x from "./../assets/CertificationsPage/Certificates/7PhotoshopCertificate/PhotoshopCertificate_2x.webp";
import PhotoshopCertificate_M1x from "./../assets/CertificationsPage/Certificates/0Mobile/7PhotoshopCertificate/PhotoshopCertificate_1x.webp";
import PhotoshopCertificate_M2x from "./../assets/CertificationsPage/Certificates/0Mobile/7PhotoshopCertificate/PhotoshopCertificate_2x.webp";

// 8
import XdLogo_1x from "./../assets/CertificationsPage/Logos/8XdLogo/XdLogo_1x.webp";
import XdLogo_2x from "./../assets/CertificationsPage/Logos/8XdLogo/XdLogo_2x.webp";
import XdLogo_M1x from "./../assets/CertificationsPage/Logos/0Mobile/8XdLogo/XdLogo_1x.webp";
import XdLogo_M2x from "./../assets/CertificationsPage/Logos/0Mobile/8XdLogo/XdLogo_2x.webp";

import XdCertificate_1x from "./../assets/CertificationsPage/Certificates/8XdCertificate/XdCertificate_1x.webp";
import XdCertificate_2x from "./../assets/CertificationsPage/Certificates/8XdCertificate/XdCertificate_2x.webp";
import XdCertificate_M1x from "./../assets/CertificationsPage/Certificates/0Mobile/8XdCertificate/XdCertificate_1x.webp";
import XdCertificate_M2x from "./../assets/CertificationsPage/Certificates/0Mobile/8XdCertificate/XdCertificate_2x.webp";

// 9
import ReactLogo_1x from "./../assets/CertificationsPage/Logos/10ReactLogo/ReactLogo_1x.webp";
import ReactLogo_2x from "./../assets/CertificationsPage/Logos/10ReactLogo/ReactLogo_2x.webp";
import ReactLogo_M1x from "./../assets/CertificationsPage/Logos/0Mobile/10ReactLogo/ReactLogo_1x.webp";
import ReactLogo_M2x from "./../assets/CertificationsPage/Logos/0Mobile/10ReactLogo/ReactLogo_2x.webp";

import ReactCertificate_1x from "./../assets/CertificationsPage/Certificates/9ReactCertificate/ReactCertificate_1x.webp";
import ReactCertificate_2x from "./../assets/CertificationsPage/Certificates/9ReactCertificate/ReactCertificate_2x.webp";
import ReactCertificate_M1x from "./../assets/CertificationsPage/Certificates/0Mobile/9ReactCertificate/ReactCertificate_1x.webp";
import ReactCertificate_M2x from "./../assets/CertificationsPage/Certificates/0Mobile/9ReactCertificate/ReactCertificate_2x.webp";

// 10
import AngularLogo_1x from "./../assets/CertificationsPage/Logos/9AngularLogo/AngularLogo_1x.webp";
import AngularLogo_2x from "./../assets/CertificationsPage/Logos/9AngularLogo/AngularLogo_2x.webp";
import AngularLogo_M1x from "./../assets/CertificationsPage/Logos/0Mobile/9AngularLogo/AngularLogo_1x.webp";
import AngularLogo_M2x from "./../assets/CertificationsPage/Logos/0Mobile/9AngularLogo/AngularLogo_2x.webp";

import AngularCertificate_1x from "./../assets/CertificationsPage/Certificates/10AngularCertificate/AngularCertificate_1x.webp";
import AngularCertificate_2x from "./../assets/CertificationsPage/Certificates/10AngularCertificate/AngularCertificate_2x.webp";
import AngularCertificate_M1x from "./../assets/CertificationsPage/Certificates/0Mobile/10AngularCertificate/AngularCertificate_1x.webp";
import AngularCertificate_M2x from "./../assets/CertificationsPage/Certificates/0Mobile/10AngularCertificate/AngularCertificate_2x.webp";

// 11
import IonicLogo_1x from "./../assets/CertificationsPage/Logos/11IonicLogo/IonicLogo_1x.webp";
import IonicLogo_2x from "./../assets/CertificationsPage/Logos/11IonicLogo/IonicLogo_2x.webp";
import IonicLogo_M1x from "./../assets/CertificationsPage/Logos/0Mobile/11IonicLogo/IonicLogo_1x.webp";
import IonicLogo_M2x from "./../assets/CertificationsPage/Logos/0Mobile/11IonicLogo/IonicLogo_2x.webp";

import IonicCertificate_1x from "./../assets/CertificationsPage/Certificates/11IonicCertificate/IonicCertificate_1x.webp";
import IonicCertificate_2x from "./../assets/CertificationsPage/Certificates/11IonicCertificate/IonicCertificate_2x.webp";
import IonicCertificate_M1x from "./../assets/CertificationsPage/Certificates/0Mobile/11IonicCertificate/IonicCertificate_1x.webp";
import IonicCertificate_M2x from "./../assets/CertificationsPage/Certificates/0Mobile/11IonicCertificate/IonicCertificate_2x.webp";

// 12
import Vue_Logo_1x from "./../assets/CertificationsPage/Logos/12Vue_Logo/Vue_Logo_1x.webp";
import Vue_Logo_2x from "./../assets/CertificationsPage/Logos/12Vue_Logo/Vue_Logo_2x.webp";
import Vue_Logo_M1x from "./../assets/CertificationsPage/Logos/0Mobile/12VueLogo/VueLogo_1x.webp";
import Vue_Logo_M2x from "./../assets/CertificationsPage/Logos/0Mobile/12VueLogo/VueLogo_2x.webp";

import VueJSCertificate_1x from "./../assets/CertificationsPage/Certificates/12VueJSCertificate/VueJSCertificate_1x.webp";
import VueJSCertificate_2x from "./../assets/CertificationsPage/Certificates/12VueJSCertificate/VueJSCertificate_2x.webp";
import VueJSCertificate_M1x from "./../assets/CertificationsPage/Certificates/0Mobile/12VueJSCertificate/VueJSCertificate_1x.webp";
import VueJSCertificate_M2x from "./../assets/CertificationsPage/Certificates/0Mobile/12VueJSCertificate/VueJSCertificate_2x.webp";

// 13
import ScssLogo_1x from "./../assets/CertificationsPage/Logos/13ScssLogo/ScssLogo_1x.webp";
import ScssLogo_2x from "./../assets/CertificationsPage/Logos/13ScssLogo/ScssLogo_2x.webp";
import ScssLogo_M1x from "./../assets/CertificationsPage/Logos/0Mobile/13ScssLogo/ScssLogo_1x.webp";
import ScssLogo_M2x from "./../assets/CertificationsPage/Logos/0Mobile/13ScssLogo/ScssLogo_2x.webp";

import ScssCertificate_1x from "./../assets/CertificationsPage/Certificates/13ScssCertificate/ScssCertificate_1x.webp";
import ScssCertificate_2x from "./../assets/CertificationsPage/Certificates/13ScssCertificate/ScssCertificate_2x.webp";
import ScssCertificate_M1x from "./../assets/CertificationsPage/Certificates/0Mobile/13ScssCertificate/ScssCertificate_1x.webp";
import ScssCertificate_M2x from "./../assets/CertificationsPage/Certificates/0Mobile/13ScssCertificate/ScssCertificate_2x.webp";

// 14
import JSLogo_1x from "./../assets/CertificationsPage/Logos/14JSLogo/JSLogo_1x.webp";
import JSLogo_2x from "./../assets/CertificationsPage/Logos/14JSLogo/JSLogo_2x.webp";
import JSLogo_M1x from "./../assets/CertificationsPage/Logos/0Mobile/14JSLogo/JSLogo_1x.webp";
import JSLogo_M2x from "./../assets/CertificationsPage/Logos/0Mobile/14JSLogo/JSLogo_2x.webp";

import JSCertificate_1x from "./../assets/CertificationsPage/Certificates/14JSCertificate/JSCertificate_1x.webp";
import JSCertificate_2x from "./../assets/CertificationsPage/Certificates/14JSCertificate/JSCertificate_2x.webp";
import JSCertificate_M1x from "./../assets/CertificationsPage/Certificates/0Mobile/14JSCertificate/JSCertificate_1x.webp";
import JSCertificate_M2x from "./../assets/CertificationsPage/Certificates/0Mobile/14JSCertificate/JSCertificate_2x.webp";

// 15
import HtmlCssLogo_1x from "./../assets/CertificationsPage/Logos/15HtmlCssLogo/HtmlCssLogo_1x.webp";
import HtmlCssLogo_2x from "./../assets/CertificationsPage/Logos/15HtmlCssLogo/HtmlCssLogo_2x.webp";
import HtmlCssLogo_M1x from "./../assets/CertificationsPage/Logos/0Mobile/15HtmlCssLogo/HtmlCssLogo_1x.webp";
import HtmlCssLogo_M2x from "./../assets/CertificationsPage/Logos/0Mobile/15HtmlCssLogo/HtmlCssLogo_2x.webp";

import HtmlCssCertificate_1x from "./../assets/CertificationsPage/Certificates/15HtmlCssCertificate/HtmlCssCertificate_1x.webp";
import HtmlCssCertificate_2x from "./../assets/CertificationsPage/Certificates/15HtmlCssCertificate/HtmlCssCertificate_2x.webp";
import HtmlCssCertificate_M1x from "./../assets/CertificationsPage/Certificates/0Mobile/15HtmlCssCertificate/HtmlCssCertificate_1x.webp";
import HtmlCssCertificate_M2x from "./../assets/CertificationsPage/Certificates/0Mobile/15HtmlCssCertificate/HtmlCssCertificate_2x.webp";

// 16
import TSLogo_1x from "./../assets/CertificationsPage/Logos/16TSLogo/TSLogo_1x.webp";
import TSLogo_2x from "./../assets/CertificationsPage/Logos/16TSLogo/TSLogo_2x.webp";
import TSLogo_M1x from "./../assets/CertificationsPage/Logos/0Mobile/16TSLogo/TSLogo_1x.webp";
import TSLogo_M2x from "./../assets/CertificationsPage/Logos/0Mobile/16TSLogo/TSLogo_2x.webp";

import TSCertificate_1x from "./../assets/CertificationsPage/Certificates/16TSCertificate/TSCertificate_1x.webp";
import TSCertificate_2x from "./../assets/CertificationsPage/Certificates/16TSCertificate/TSCertificate_2x.webp";
import TSCertificate_M1x from "./../assets/CertificationsPage/Certificates/0Mobile/16TSCertificate/TSCertificate_1x.webp";
import TSCertificate_M2x from "./../assets/CertificationsPage/Certificates/0Mobile/16TSCertificate/TSCertificate_2x.webp";

// 17
import AzureLogo_1x from "./../assets/CertificationsPage/Logos/17AzureLogo/AzureLogo_1x.webp";
import AzureLogo_2x from "./../assets/CertificationsPage/Logos/17AzureLogo/AzureLogo_2x.webp";
import AzureLogo_M1x from "./../assets/CertificationsPage/Logos/0Mobile/17AzureLogo/AzureLogo_1x.webp";
import AzureLogo_M2x from "./../assets/CertificationsPage/Logos/0Mobile/17AzureLogo/AzureLogo_2x.webp";

import AzureCertificate_1x from "./../assets/CertificationsPage/Certificates/17AzureCertificate/AzureCertificate_1x.webp";
import AzureCertificate_2x from "./../assets/CertificationsPage/Certificates/17AzureCertificate/AzureCertificate_2x.webp";
import AzureCertificate_M1x from "./../assets/CertificationsPage/Certificates/0Mobile/17AzureCertificate/AzureCertificate_1x.webp";
import AzureCertificate_M2x from "./../assets/CertificationsPage/Certificates/0Mobile/17AzureCertificate/AzureCertificate_2x.webp";

// 18
import AzureDevOpsLogo_1x from "./../assets/CertificationsPage/Logos/18AzureDevOpsLogo/AzureDevOpsLogo_1x.webp";
import AzureDevOpsLogo_2x from "./../assets/CertificationsPage/Logos/18AzureDevOpsLogo/AzureDevOpsLogo_2x.webp";
import AzureDevOpsLogo_M1x from "./../assets/CertificationsPage/Logos/0Mobile/18AzureDevOpsLogo/AzureDevOpsLogo_1x.webp";
import AzureDevOpsLogo_M2x from "./../assets/CertificationsPage/Logos/0Mobile/18AzureDevOpsLogo/AzureDevOpsLogo_2x.webp";

import AzureDevOpsCertificate_1x from "./../assets/CertificationsPage/Certificates/18AzureDevOpsCertificate/AzureDevOpsCertificate_1x.webp";
import AzureDevOpsCertificate_2x from "./../assets/CertificationsPage/Certificates/18AzureDevOpsCertificate/AzureDevOpsCertificate_2x.webp";
import AzureDevOpsCertificate_M1x from "./../assets/CertificationsPage/Certificates/0Mobile/18AzureDevOpsCertificate/AzureDevOpsCertificate_1x.webp";
import AzureDevOpsCertificate_M2x from "./../assets/CertificationsPage/Certificates/0Mobile/18AzureDevOpsCertificate/AzureDevOpsCertificate_2x.webp";

// 19
import DotNetLogo_1x from "./../assets/CertificationsPage/Logos/19DotNetLogo/DotNetLogo_1x.webp";
import DotNetLogo_2x from "./../assets/CertificationsPage/Logos/19DotNetLogo/DotNetLogo_2x.webp";
import DotNetLogo_M1x from "./../assets/CertificationsPage/Logos/0Mobile/19DotNetLogo/DotNetLogo_1x.webp";
import DotNetLogo_M2x from "./../assets/CertificationsPage/Logos/0Mobile/19DotNetLogo/DotNetLogo_2x.webp";

import DotNetCertificate_1x from "./../assets/CertificationsPage/Certificates/19DotNetCertificate/DotNetCertificate_1x.webp";
import DotNetCertificate_2x from "./../assets/CertificationsPage/Certificates/19DotNetCertificate/DotNetCertificate_2x.webp";
import DotNetCertificate_M1x from "./../assets/CertificationsPage/Certificates/0Mobile/19DotNetCertificate/DotNetCertificate_1x.webp";
import DotNetCertificate_M2x from "./../assets/CertificationsPage/Certificates/0Mobile/19DotNetCertificate/DotNetCertificate_2x.webp";

// 20
import JavaLogo_1x from "./../assets/CertificationsPage/Logos/20JavaLogo/JavaLogo_1x.webp";
import JavaLogo_2x from "./../assets/CertificationsPage/Logos/20JavaLogo/JavaLogo_2x.webp";
import JavaLogo_M1x from "./../assets/CertificationsPage/Logos/0Mobile/20JavaLogo/JavaLogo_1x.webp";
import JavaLogo_M2x from "./../assets/CertificationsPage/Logos/0Mobile/20JavaLogo/JavaLogo_2x.webp";

import JavaCertificate_1x from "./../assets/CertificationsPage/Certificates/20JavaCertificate/JavaCertificate_1x.webp";
import JavaCertificate_2x from "./../assets/CertificationsPage/Certificates/20JavaCertificate/JavaCertificate_2x.webp";
import JavaCertificate_M1x from "./../assets/CertificationsPage/Certificates/0Mobile/20JavaCertificate/JavaCertificate_1x.webp";
import JavaCertificate_M2x from "./../assets/CertificationsPage/Certificates/0Mobile/20JavaCertificate/JavaCertificate_2x.webp";

// 21
import CppLogo_1x from "./../assets/CertificationsPage/Logos/21CppLogo/CppLogo_1x.webp";
import CppLogo_2x from "./../assets/CertificationsPage/Logos/21CppLogo/CppLogo_2x.webp";
import CppLogo_M1x from "./../assets/CertificationsPage/Logos/0Mobile/21CppLogo/CppLogo_1x.webp";
import CppLogo_M2x from "./../assets/CertificationsPage/Logos/0Mobile/21CppLogo/CppLogo_2x.webp";

import CppCertificate_1x from "./../assets/CertificationsPage/Certificates/21CppCertificate/CppCertificate_1x.webp";
import CppCertificate_2x from "./../assets/CertificationsPage/Certificates/21CppCertificate/CppCertificate_2x.webp";
import CppCertificate_M1x from "./../assets/CertificationsPage/Certificates/0Mobile/21CppCertificate/CppCertificate_1x.webp";
import CppCertificate_M2x from "./../assets/CertificationsPage/Certificates/0Mobile/21CppCertificate/CppCertificate_2x.webp";

// 22
import CLogo_1x from "./../assets/CertificationsPage/Logos/22CLogo/CLogo_1x.webp";
import CLogo_2x from "./../assets/CertificationsPage/Logos/22CLogo/CLogo_2x.webp";
import CLogo_M1x from "./../assets/CertificationsPage/Logos/0Mobile/22CLogo/CLogo_1x.webp";
import CLogo_M2x from "./../assets/CertificationsPage/Logos/0Mobile/22CLogo/CLogo_2x.webp";

import CCertificate_1x from "./../assets/CertificationsPage/Certificates/22CCertificate/CCertificate_1x.webp";
import CCertificate_2x from "./../assets/CertificationsPage/Certificates/22CCertificate/CCertificate_2x.webp";
import CCertificate_M1x from "./../assets/CertificationsPage/Certificates/0Mobile/22CCertificate/CCertificate_1x.webp";
import CCertificate_M2x from "./../assets/CertificationsPage/Certificates/0Mobile/22CCertificate/CCertificate_2x.webp";

// 23
import CorelDrawLogo_1x from "./../assets/CertificationsPage/Logos/23CorelDrawLogo/CorelDrawLogo_1x.webp";
import CorelDrawLogo_2x from "./../assets/CertificationsPage/Logos/23CorelDrawLogo/CorelDrawLogo_2x.webp";
import CorelDrawLogo_M1x from "./../assets/CertificationsPage/Logos/0Mobile/23CorelDrawLogo/CorelDrawLogo_1x.webp";
import CorelDrawLogo_M2x from "./../assets/CertificationsPage/Logos/0Mobile/23CorelDrawLogo/CorelDrawLogo_2x.webp";

import CoreDrawCertificate_1x from "./../assets/CertificationsPage/Certificates/23CoreDrawCertificate/CoreDrawCertificate_1x.webp";
import CoreDrawCertificate_2x from "./../assets/CertificationsPage/Certificates/23CoreDrawCertificate/CoreDrawCertificate_2x.webp";
import CoreDrawCertificate_M1x from "./../assets/CertificationsPage/Certificates/0Mobile/23CoreDrawCertificate/CoreDrawCertificate_1x.webp";
import CoreDrawCertificate_M2x from "./../assets/CertificationsPage/Certificates/0Mobile/23CoreDrawCertificate/CoreDrawCertificate_2x.webp";

// 24
import MSOfficeLogo_1x from "./../assets/CertificationsPage/Logos/24MSOfficeLogo/MSOfficeLogo_1x.webp";
import MSOfficeLogo_2x from "./../assets/CertificationsPage/Logos/24MSOfficeLogo/MSOfficeLogo_2x.webp";
import MSOfficeLogo_M1x from "./../assets/CertificationsPage/Logos/0Mobile/24MSOfficeLogo/MSOfficeLogo_1x.webp";
import MSOfficeLogo_M2x from "./../assets/CertificationsPage/Logos/0Mobile/24MSOfficeLogo/MSOfficeLogo_2x.webp";

import MscitCertificate_1x from "./../assets/CertificationsPage/Certificates/24MscitCertificate/MscitCertificate_1x.webp";
import MscitCertificate_2x from "./../assets/CertificationsPage/Certificates/24MscitCertificate/MscitCertificate_2x.webp";
import MscitCertificate_M1x from "./../assets/CertificationsPage/Certificates/0Mobile/24MscitCertificate/MscitCertificate_1x.webp";
import MscitCertificate_M2x from "./../assets/CertificationsPage/Certificates/0Mobile/24MscitCertificate/MscitCertificate_2x.webp";

import ListPage from "../components/List/List";

import { useEffect } from "react";

export default function CertificationsPage() {
  async function setPageHitsOnDB() {
    const url =
      "https://jagdishchopde-profile-default-rtdb.firebaseio.com/dataCertificationsPage.json";
    try {
      const response = await fetch(url);
      if (response.ok) {
        const json = await response.json();

        fetch(url, {
          method: "PUT",
          body: JSON.stringify({ pageHits: +json.pageHits + 1 }),
        });
      }
    } catch (error) {
      // console.error(error.message);
    }
  }

  useEffect(() => {
    setPageHitsOnDB();
  }, []);

  // Set Page Data
  const data = [
    {
      id: 1,
      card: {
        date: "9 mar 2013",
        title: "Microsoft Specialist",
        subText: "Microsoft Certification ID: 9752619",
        image1x: MSSpecialistLogo_1x,
        image2x: MSSpecialistLogo_2x,
        imageM1x: MSSpecialistLogo_M1x,
        imageM2x: MSSpecialistLogo_M2x,
        alt: "MS Specialist Logo",
      },
      popup: [
        {
          id: 1,
          image1x: MSSpecialistCertificate_1x,
          image2x: MSSpecialistCertificate_2x,
          imageM1x: MSSpecialistCertificate_M1x,
          imageM2x: MSSpecialistCertificate_M2x,
          alt: "MS Specialist Certificate",
        },
      ],
    },

    {
      id: 2,
      card: {
        date: "13 Aug 2013",
        title: "Microsoft Certified Solution Developer (MCSD)",
        subText: "Microsoft Certification ID: 9752619",
        image1x: MSSolutionDevLogo_1x,
        image2x: MSSolutionDevLogo_2x,
        imageM1x: MSSolutionDevLogo_M1x,
        imageM2x: MSSolutionDevLogo_M2x,
        alt: "MS Solution Dev Logo",
      },
      popup: [
        {
          id: 1,
          image1x: MSSolutionDevCertificate_1x,
          image2x: MSSolutionDevCertificate_2x,
          imageM1x: MSSolutionDevCertificate_M1x,
          imageM2x: MSSolutionDevCertificate_M2x,
          alt: "MS Solution Dev Certificate",
        },
      ],
    },
    {
      id: 3,
      card: {
        date: "31 jul 2013",
        title: "Microsoft Certified Professional",
        subText: "Microsoft Certification ID: 9752619",
        image1x: MSCertifiedLogo_1x,
        image2x: MSCertifiedLogo_2x,
        imageM1x: MSCertifiedLogo_M1x,
        imageM2x: MSCertifiedLogo_M2x,
        alt: "MS Certified Logo",
      },
      popup: [
        {
          id: 1,
          image1x: MSCertifiedCertificate_1x,
          image2x: MSCertifiedCertificate_2x,
          imageM1x: MSCertifiedCertificate_M1x,
          imageM2x: MSCertifiedCertificate_M2x,
          alt: "MS Certified Certificate",
        },
      ],
    },
    {
      id: 4,
      card: {
        date: "24 SEP 2024",
        title: "Design Thinking & UX Design",
        subText: "Interaction Design Foundation | Membership No. 177356",
        image1x: IxDFLogo_1x,
        image2x: IxDFLogo_2x,
        imageM1x: IxDFLogo_M1x,
        imageM2x: IxDFLogo_M2x,
        alt: "IxDF Logo",
      },
      popup: [
        {
          id: 1,
          image1x: IxDF1Certificate_1x,
          image2x: IxDF1Certificate_2x,
          imageM1x: IxDF1Certificate_M1x,
          imageM2x: IxDF1Certificate_M2x,
          alt: "IxDF Certificate",
        },
        {
          id: 2,
          image1x: IxDF2Certificate_1x,
          image2x: IxDF2Certificate_2x,
          imageM1x: IxDF2Certificate_M1x,
          imageM2x: IxDF2Certificate_M2x,
          alt: "IxDF Certificate",
        },
        {
          id: 3,
          image1x: IxDF3Certificate_1x,
          image2x: IxDF3Certificate_2x,
          imageM1x: IxDF3Certificate_M1x,
          imageM2x: IxDF3Certificate_M2x,
          alt: "IxDF Certificate",
        },
        {
          id: 4,
          image1x: IxDF4Certificate_1x,
          image2x: IxDF4Certificate_2x,
          imageM1x: IxDF4Certificate_M1x,
          imageM2x: IxDF4Certificate_M2x,
          alt: "IxDF Certificate",
        },
        {
          id: 5,
          image1x: IxDF5Certificate_1x,
          image2x: IxDF5Certificate_2x,
          imageM1x: IxDF5Certificate_M1x,
          imageM2x: IxDF5Certificate_M2x,
          alt: "IxDF Certificate",
        },
      ],
    },
    {
      id: 5,
      card: {
        date: "24 jan 2024",
        title: "Figma UI UX Design Advanced",
        subText: "Udemy | Daniel Walter Scott",
        image1x: FigmaLogo_1x,
        image2x: FigmaLogo_2x,
        imageM1x: FigmaLogo_M1x,
        imageM2x: FigmaLogo_M2x,
        alt: "Figma Logo",
      },
      popup: [
        {
          id: 1,
          image1x: FigmaAdvancedCertificate_1x,
          image2x: FigmaAdvancedCertificate_2x,
          imageM1x: FigmaAdvancedCertificate_M1x,
          imageM2x: FigmaAdvancedCertificate_M2x,
          alt: "Figma Advanced Certificate",
        },
        {
          id: 2,
          image1x: FigmaBasicCertificate_1x,
          image2x: FigmaBasicCertificate_2x,
          imageM1x: FigmaBasicCertificate_M1x,
          imageM2x: FigmaBasicCertificate_M2x,
          alt: "Figma Basic Certificate",
        },
      ],
    },
    {
      id: -2,
      card: {
        date: "3 apr 2026",
        title: "Claude Code - The AI Coding",
        subText: "Udemy | Maximilian Schwarzmuller",
        image1x: ClaudeCodeLogo_1x,
        image2x: ClaudeCodeLogo_2x,
        imageM1x: ClaudeCodeLogo_1x,
        imageM2x: ClaudeCodeLogo_2x,
        alt: "Claude Code Logo",
      },
      popup: [
        {
          id: 1,
          image1x: ClaudeCodeCertificate_1x,
          image2x: ClaudeCodeCertificate_2x,
          imageM1x: ClaudeCodeCertificate_1x,
          imageM2x: ClaudeCodeCertificate_2x,
          alt: "Claude Code Certificate",
        },
      ],
    },
    
    {
      id: -3,
      card: {
        date: "3 apr 2026",
        title: "GitHub Copilot - The AI Coding",
        subText: "Udemy | Tom Phillips, WebDevEducation",
        image1x: GitHubCopilotLogo_1x,
        image2x: GitHubCopilotLogo_2x,
        imageM1x: GitHubCopilotLogo_1x,
        imageM2x: GitHubCopilotLogo_2x,
        alt: "GitHub Copilot Logo",
      },
      popup: [
        {
          id: 1,
          image1x: GitHubCopilotCertificate_1x,
          image2x: GitHubCopilotCertificate_2x,
          imageM1x: GitHubCopilotCertificate_1x,
          imageM2x: GitHubCopilotCertificate_2x,
          alt: "GitHub Copilot Certificate",
        },
      ],
    },
    {
      id: -1,
      card: {
        date: "3 apr 2026",
        title: "Next.js - The React Framework",
        subText: "Udemy | Maximilian Schwarzmuller",
        image1x: NextJSLogo_1x,
        image2x: NextJSLogo_2x,
        imageM1x: NextJSLogo_1x,
        imageM2x: NextJSLogo_2x,
        alt: "Next.js Logo",
      },
      popup: [
        {
          id: 1,
          image1x: NextJSCertificate_1x,
          image2x: NextJSCertificate_2x,
          imageM1x: NextJSCertificate_1x,
          imageM2x: NextJSCertificate_2x,
          alt: "Next.js Certificate",
        },
      ],
    },
    {
      id: 6,
      card: {
        date: "15 sep 2024",
        title: "Adobe Illustrator CC",
        subText: "Udemy | Video School, Phil Ebiner, Daniel Walter Scott",
        image1x: IllustratorLogo_1x,
        image2x: IllustratorLogo_2x,
        imageM1x: IllustratorLogo_M1x,
        imageM2x: IllustratorLogo_M2x,
        alt: "Illustrator Logo",
      },
      popup: [
        {
          id: 1,
          image1x: IllustratorCertificate_1x,
          image2x: IllustratorCertificate_2x,
          imageM1x: IllustratorCertificate_M1x,
          imageM2x: IllustratorCertificate_M2x,
          alt: "Illustrator Essentials Certificate",
        },
      ],
    },
    {
      id: 7,
      card: {
        date: "15 sep 2024",
        title: "Adobe Photoshop CC",
        subText: "Udemy | Video School, Phil Ebiner, Daniel Walter Scott",
        image1x: PhotoshopLogo_1x,
        image2x: PhotoshopLogo_2x,
        imageM1x: PhotoshopLogo_M1x,
        imageM2x: PhotoshopLogo_M2x,
        alt: "Photoshop Logo",
      },
      popup: [
        {
          id: 1,
          image1x: PhotoshopCertificate_1x,
          image2x: PhotoshopCertificate_2x,
          imageM1x: PhotoshopCertificate_M1x,
          imageM2x: PhotoshopCertificate_M2x,
          alt: "Photoshop Essentials Certificate",
        },
      ],
    },
    {
      id: 8,
      card: {
        date: "15 jan 2024",
        title: "Adobe XD - User Experience Design",
        subText: "Udemy | Daniel Walter Scott",
        image1x: XdLogo_1x,
        image2x: XdLogo_2x,
        imageM1x: XdLogo_M1x,
        imageM2x: XdLogo_M2x,
        alt: "Adobe Xd Logo",
      },
      popup: [
        {
          id: 1,
          image1x: XdCertificate_1x,
          image2x: XdCertificate_2x,
          imageM1x: XdCertificate_M1x,
          imageM2x: XdCertificate_M2x,
          alt: "Adobe Xd Certificate",
        },
      ],
    },
    {
      id: 9,
      card: {
        date: "22 may 2021",
        title: "Master in React Certification",
        subText: "Udemy | Maximilian Schwarzmuller",
        image1x: ReactLogo_1x,
        image2x: ReactLogo_2x,
        imageM1x: ReactLogo_M1x,
        imageM2x: ReactLogo_M2x,
        alt: "React Logo",
      },
      popup: [
        {
          id: 1,
          image1x: ReactCertificate_1x,
          image2x: ReactCertificate_2x,
          imageM1x: ReactCertificate_M1x,
          imageM2x: ReactCertificate_M2x,
          alt: "React Certificate",
        },
      ],
    },
    {
      id: 10,
      card: {
        date: "7 jun 2021",
        title: "Master in Angular Certification",
        subText: "Udemy | Maximilian Schwarzmuller",
        image1x: AngularLogo_1x,
        image2x: AngularLogo_2x,
        imageM1x: AngularLogo_M1x,
        imageM2x: AngularLogo_M2x,
        alt: "Angular Logo",
      },
      popup: [
        {
          id: 1,
          image1x: AngularCertificate_1x,
          image2x: AngularCertificate_2x,
          imageM1x: AngularCertificate_M1x,
          imageM2x: AngularCertificate_M2x,
          alt: "Angular Certificate",
        },
      ],
    },
    {
      id: 11,
      card: {
        date: "2 jul 2020",
        title: "Master in Ionic Certification",
        subText: "Udemy | Maximilian Schwarzmuller",
        image1x: IonicLogo_1x,
        image2x: IonicLogo_2x,
        imageM1x: IonicLogo_M1x,
        imageM2x: IonicLogo_M2x,
        alt: "Ionic Logo",
      },
      popup: [
        {
          id: 1,
          image1x: IonicCertificate_1x,
          image2x: IonicCertificate_2x,
          imageM1x: IonicCertificate_M1x,
          imageM2x: IonicCertificate_M2x,
          alt: "Ionic Certificate",
        },
      ],
    },
    {
      id: 12,
      card: {
        date: "4 oct 2024",
        title: "VueJS SPA Certification",
        subText: "Udemy | Maximilian Schwarzmuller",
        image1x: Vue_Logo_1x,
        image2x: Vue_Logo_2x,
        imageM1x: Vue_Logo_M1x,
        imageM2x: Vue_Logo_M2x,
        alt: "Vue Logo",
      },
      popup: [
        {
          id: 1,
          image1x: VueJSCertificate_1x,
          image2x: VueJSCertificate_2x,
          imageM1x: VueJSCertificate_M1x,
          imageM2x: VueJSCertificate_M2x,
          alt: "VueJS Certificate",
        },
      ],
    },
    {
      id: 13,
      card: {
        date: "6 may 2021",
        title: "Advanced CSS, SASS, SCSS Web Styling Certification",
        subText: "Udemy | Jonas Schmedtmann",
        image1x: ScssLogo_1x,
        image2x: ScssLogo_2x,
        imageM1x: ScssLogo_M1x,
        imageM2x: ScssLogo_M2x,
        alt: "Scss Logo",
      },
      popup: [
        {
          id: 1,
          image1x: ScssCertificate_1x,
          image2x: ScssCertificate_2x,
          imageM1x: ScssCertificate_M1x,
          imageM2x: ScssCertificate_M2x,
          alt: "SCSS Certificate",
        },
      ],
    },
    {
      id: 14,
      card: {
        date: "27 nov 2022",
        title: "Advanced JavaScript (ES6) Certification",
        subText: "Udemy | Jonas Schmedtmann",
        image1x: JSLogo_1x,
        image2x: JSLogo_2x,
        imageM1x: JSLogo_M1x,
        imageM2x: JSLogo_M2x,
        alt: "JS Logo",
      },
      popup: [
        {
          id: 1,
          image1x: JSCertificate_1x,
          image2x: JSCertificate_2x,
          imageM1x: JSCertificate_M1x,
          imageM2x: JSCertificate_M2x,
          alt: "JS Certificate",
        },
      ],
    },
    {
      id: 15,
      card: {
        date: "22 apr 2021",
        title: "Advanced Responsive HTML 5 & CSS 3 Certification",
        subText: "Udemy | Jonas Schmedtmann",
        image1x: HtmlCssLogo_1x,
        image2x: HtmlCssLogo_2x,
        imageM1x: HtmlCssLogo_M1x,
        imageM2x: HtmlCssLogo_M2x,
        alt: "Html CSS Logo",
      },
      popup: [
        {
          id: 1,
          image1x: HtmlCssCertificate_1x,
          image2x: HtmlCssCertificate_2x,
          imageM1x: HtmlCssCertificate_M1x,
          imageM2x: HtmlCssCertificate_M2x,
          alt: "Html CSS Certificate",
        },
      ],
    },
    {
      id: 16,
      card: {
        date: "8 sep 2019",
        title: "Advanced TypeScript (Angular) Certification",
        subText: "Udemy | Code with Mosh",
        image1x: TSLogo_1x,
        image2x: TSLogo_2x,
        imageM1x: TSLogo_M1x,
        imageM2x: TSLogo_M2x,
        alt: "TS Logo",
      },
      popup: [
        {
          id: 1,
          image1x: TSCertificate_1x,
          image2x: TSCertificate_2x,
          imageM1x: TSCertificate_M1x,
          imageM2x: TSCertificate_M2x,
          alt: "TS Certificate",
        },
      ],
    },
    {
      id: 17,
      card: {
        date: "20 jul 2021",
        title: "Microsoft Azure Fundamentals Certification (AZ-900)",
        subText: "Microsoft Certification ID: 9752619",
        image1x: AzureLogo_1x,
        image2x: AzureLogo_2x,
        imageM1x: AzureLogo_M1x,
        imageM2x: AzureLogo_M2x,
        alt: "Azure Logo",
      },
      popup: [
        {
          id: 1,
          image1x: AzureCertificate_1x,
          image2x: AzureCertificate_2x,
          imageM1x: AzureCertificate_M1x,
          imageM2x: AzureCertificate_M2x,
          alt: "Azure Certificate",
        },
      ],
    },
    {
      id: 18,
      card: {
        date: "16 jul 2021",
        title: "Microsoft Azure DevOps Certification",
        subText: "Udemy | Brian Culp",
        image1x: AzureDevOpsLogo_1x,
        image2x: AzureDevOpsLogo_2x,
        imageM1x: AzureDevOpsLogo_M1x,
        imageM2x: AzureDevOpsLogo_M2x,
        alt: "Azure DevOps Logo",
      },
      popup: [
        {
          id: 1,
          image1x: AzureDevOpsCertificate_1x,
          image2x: AzureDevOpsCertificate_2x,
          imageM1x: AzureDevOpsCertificate_M1x,
          imageM2x: AzureDevOpsCertificate_M2x,
          alt: "Azure DevOps Certificate",
        },
      ],
    },
    {
      id: 19,
      card: {
        date: "oct 2010",
        title: "Microsoft .Net Certification",
        subText: "Training by Ajay Kamat | Nashik",
        image1x: DotNetLogo_1x,
        image2x: DotNetLogo_2x,
        imageM1x: DotNetLogo_M1x,
        imageM2x: DotNetLogo_M2x,
        alt: "DotNet Logo",
      },
      popup: [
        {
          id: 1,
          image1x: DotNetCertificate_1x,
          image2x: DotNetCertificate_2x,
          imageM1x: DotNetCertificate_M1x,
          imageM2x: DotNetCertificate_M2x,
          alt: "DotNet Certificate",
        },
      ],
    },
    {
      id: 20,
      card: {
        date: "20 oct 2008",
        title: "Core Java Certification",
        subText: "Galaxy Computers | Jalgaon",
        image1x: JavaLogo_1x,
        image2x: JavaLogo_2x,
        imageM1x: JavaLogo_M1x,
        imageM2x: JavaLogo_M2x,
        alt: "Java Logo",
      },
      popup: [
        {
          id: 1,
          image1x: JavaCertificate_1x,
          image2x: JavaCertificate_2x,
          imageM1x: JavaCertificate_M1x,
          imageM2x: JavaCertificate_M2x,
          alt: "Java Certificate",
        },
      ],
    },
    {
      id: 21,
      card: {
        date: "26 JUN 2007",
        title: "C++ Programming Certification",
        subText: "Softaid Computers | Jalgaon",
        image1x: CppLogo_1x,
        image2x: CppLogo_2x,
        imageM1x: CppLogo_M1x,
        imageM2x: CppLogo_M2x,
        alt: "Cpp Logo",
      },
      popup: [
        {
          id: 1,
          image1x: CppCertificate_1x,
          image2x: CppCertificate_2x,
          imageM1x: CppCertificate_M1x,
          imageM2x: CppCertificate_M2x,
          alt: "Cpp Certificate",
        },
      ],
    },
    {
      id: 22,
      card: {
        date: "22 NOV 2006",
        title: "C Programming Certification",
        subText: "Softaid Computers | Jalgaon",
        image1x: CLogo_1x,
        image2x: CLogo_2x,
        imageM1x: CLogo_M1x,
        imageM2x: CLogo_M2x,
        alt: "C Logo",
      },
      popup: [
        {
          id: 1,
          image1x: CCertificate_1x,
          image2x: CCertificate_2x,
          imageM1x: CCertificate_M1x,
          imageM2x: CCertificate_M2x,
          alt: "C Certificate",
        },
      ],
    },
    {
      id: 23,
      card: {
        date: "8 JUN 2006",
        title: "CorelDRAW, Photoshop, Designing",
        subText: "Media Computers | Jalgaon",
        image1x: CorelDrawLogo_1x,
        image2x: CorelDrawLogo_2x,
        imageM1x: CorelDrawLogo_M1x,
        imageM2x: CorelDrawLogo_M2x,
        alt: "Corel Draw Logo",
      },
      popup: [
        {
          id: 1,
          image1x: CoreDrawCertificate_1x,
          image2x: CoreDrawCertificate_2x,
          imageM1x: CoreDrawCertificate_M1x,
          imageM2x: CoreDrawCertificate_M2x,
          alt: "Core Draw Certificate",
        },
      ],
    },
    {
      id: 24,
      card: {
        date: "JUL 2004",
        title: "MS Office, MSCIT",
        subText: "Media Computers | Jalgaon",
        image1x: MSOfficeLogo_1x,
        image2x: MSOfficeLogo_2x,
        imageM1x: MSOfficeLogo_M1x,
        imageM2x: MSOfficeLogo_M2x,
        alt: "MS Office Logo",
      },
      popup: [
        {
          id: 1,
          image1x: MscitCertificate_1x,
          image2x: MscitCertificate_2x,
          imageM1x: MscitCertificate_M1x,
          imageM2x: MscitCertificate_M2x,
          alt: "Mscit Certificate",
        },
      ],
    },
  ];

  return <ListPage pageTitle="Technology Certifications" data={data} />;
}
